"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var reducers_1 = require("../../reducers");
require("./Accordion.scss");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var Accordion = function (props) {
    var title = props.title, onRenderTitle = props.onRenderTitle, isOpen = props.isOpen, onStateChange = props.onStateChange, children = props.children, alwaysVisibleChildren = props.alwaysVisibleChildren, currentLang = props.currentLang;
    var _a = react_2.useState(isOpen !== null && isOpen !== void 0 ? isOpen : false), isOpenState = _a[0], setIsOpenState = _a[1];
    react_2.useEffect(function () {
        setIsOpenState(isOpen !== null && isOpen !== void 0 ? isOpen : false);
    }, [isOpen]);
    var changeState = function (newState) {
        if (onStateChange) {
            onStateChange(newState);
        }
        else {
            setIsOpenState(newState);
        }
    };
    var chevronSide = currentLang.isRtl ? 'ChevronLeft' : 'ChevronRight';
    return (react_2.default.createElement("div", { className: 'eta-accordion' },
        react_2.default.createElement("div", { className: 'eta-accordion-header', role: 'button', tabIndex: 0, onKeyUp: function (key) {
                if (key.key === ' ') {
                    changeState(!isOpenState);
                }
            }, onClick: function () {
                changeState(!isOpenState);
            } },
            react_2.default.createElement(react_1.Icon, { className: 'eta-accordion-indicator', iconName: isOpenState ? 'ChevronDown' : chevronSide }),
            onRenderTitle ? onRenderTitle(title) : react_2.default.createElement("span", null, title)),
        alwaysVisibleChildren && (react_2.default.createElement("div", { className: 'eta-accordion-body' },
            alwaysVisibleChildren,
            react_2.default.createElement("div", { style: !isOpenState ? { display: 'none' } : undefined }, children))),
        !alwaysVisibleChildren && (react_2.default.createElement("div", { className: 'eta-accordion-body', style: !isOpenState ? { display: 'none' } : undefined }, children))));
};
exports.default = connector(Accordion);
//# sourceMappingURL=Accordion.js.map